import React from 'react';
import { MessageCircle, X } from 'lucide-react';

/**
 * Top bar of the chat widget — title, dynamic status line, "+" new-chat icon and close.
 */
const ChatHeader = ({ conversation, hasConversation, onNewChat, onClose }) => {
  const statusText =
    conversation?.status === 'closed'
      ? 'Chat ended'
      : conversation?.assigned_agent
        ? `You are now connected with ${conversation.assigned_agent}`
        : 'We typically reply within minutes';

  return (
    <div className="bg-green-600 text-white p-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
          <MessageCircle className="h-5 w-5" />
        </div>
        <div>
          <h3 className="font-semibold">Daye Farm Support</h3>
          <p className="text-xs text-green-100">{statusText}</p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        {hasConversation && (
          <button onClick={onNewChat} className="hover:bg-white/20 p-2 rounded-full transition-colors text-xs" title="New Chat">
            +
          </button>
        )}
        <button onClick={onClose} className="hover:bg-white/20 p-2 rounded-full transition-colors">
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
